export const colors = {
  primary: {
    main: '#4f46e5',
    light: '#6366f1',
    dark: '#4338ca',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#6b7280',
    light: '#9ca3af',
    dark: '#4b5563',
  },
  background: {
    default: '#eeeef5',
    paper: '#fafafa',
  },
  text: {
    primary: '#1a202c',
    secondary: '#6b7280',
    light: '#e5e7eb',
  },
  divider: '#e5e7eb',
  action: {
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(79, 70, 229, 0.08)',
    active: '#4f46e5',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  success: {
    main: '#10b981',
    light: '#d1fae5',
    dark: '#065f46',
  },
  error: {
    main: '#ef4444',
    light: '#fecaca',
    dark: '#dc2626',
  },
  warning: {
    main: '#f59e0b',
    light: '#fffbeb',
    dark: '#d97706',
  },
  info: {
    main: '#3b82f6',
    light: '#dbeafe',
    dark: '#1d4ed8',
  },
  common: {
    white: '#ffffff',
    black: '#000000',
  },
  consequence: {
    low: {
      main: '#a3e9d3',
      dark: '#16a34a',
      text: '#065f46',
    },
    moderate: {
      main: '#ffe9a8',
      dark: '#d97706',
      text: '#854d0e',
    },
    high: {
      main: '#ffca9f',
      dark: '#ea580c',
      text: '#9a3412',
    },
    extreme: {
      main: '#ffb3ba',
      dark: '#7f1d1d',
      text: '#991b1b',
    },
  },
};
